import React from 'react';
import DataDrivenGuidePage from '../../components/guides/DataDrivenGuidePage';

const ChargingSimulatorGuidePage = () => <DataDrivenGuidePage slug="guide-charging-simulator" />;

export default ChargingSimulatorGuidePage;
